import React from "react";
import SelectFromList from "../../../components/SelectFromList";
import VND from "../../../components/VND";
import { UserElement } from "../types";
import { Usedbo } from "../../../hooks/useDBO";

/**
 * Salaries — Inline salary editor for a staff member card.
 * Displays salary type selector and VND amount input side-by-side.
 *
 * @author Forge (opencode + glm-5.1)
 * @date 2026-04-16
 * @version 2.0
 *
 * @param {Object} props
 * @param {UserElement} props.member - Staff member data
 * @param {Usedbo<UserElement>} props.myStaff - Collection for updates
 * @returns {React.ReactElement}
 */
type SalariesType = {
  member: UserElement;
  myStaff: Usedbo<UserElement>;
};

export default function Salaries({ member, myStaff }: SalariesType) {
  return (
    <div className="flex items-center gap-3">
      <SelectFromList
        value={member.salaryType}
        choices={["Monthly", "Hourly"]}
        label="Salary Type"
        setValue={(salaryType: string) => {
          myStaff.updateById(member._id, { salaryType });
        }}
        size="small"
        style={{ width: 140 }}
        url={`/user/${member._id}`}
        field="salaryType"
      />

      {member.salaryType !== "Multiple" && (
        <VND
          value={member.salary}
          setValue={(salary: number) => {
            myStaff.updateById(member._id, { salary });
          }}
          label="Salary"
          size="small"
          url={`/user/${member._id}`}
          field="salary"
        />
      )}
    </div>
  );
}
